import { formatting } from "@/lib/formatting";

import { TrophyAwardType } from "@/types";

export const trophies = {
  value: (type: TrophyAwardType, value: number): string => {
    if (type === TrophyAwardType.REVENUE) return formatting.currency(value);
    if (type === TrophyAwardType.BEST_TTFS) {
      return `${value.toLocaleString("en-US")} ${value === 1 ? "hour" : "hours"}`;
    }
    if (type === TrophyAwardType.MOST_VERSATILE) {
      return `${value.toLocaleString("en-US")} companies`;
    }
    if (type === TrophyAwardType.SCREENS) {
      return `${value.toLocaleString("en-US")} screens`;
    }
    if (type === TrophyAwardType.SUBMITTALS) {
      return `${value.toLocaleString("en-US")} submissions`;
    }
    if (type === TrophyAwardType.INTERVIEWS) {
      return `${value.toLocaleString("en-US")} interviews`;
    }
    return `${value.toLocaleString("en-US")} placements`;
  },
};
